(function () {
  'use strict';

  var AGE_TO_PHASE = {
    '0-1': 'phase_1',
    '1-3': 'phase_2',
    '3-5': 'phase_3',
    '5-9': 'phase_4',
    '9-12': 'phase_5'
  };

  var DECISION_STEPS = ['situation', 'detail', 'plan'];
  var MODAL_ID = 'ai-scar-analyser';

  function parseConfig(root) {
    var section = root.closest('.cta-product-quiz');
    var configEl =
      (section && section.querySelector('[data-cpq-config]')) ||
      root.querySelector('[data-cpq-config]');
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getTemplate(section) {
    return section ? section.querySelector('[data-cpq-product-template]') : null;
  }

  function openAnalyserModal() {
    var modalEl = document.getElementById(MODAL_ID);
    if (!modalEl) return;
    if (window.bootstrap && window.bootstrap.Modal) {
      window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
      return;
    }
    if (window.jQuery) {
      window.jQuery(modalEl).modal('show');
    }
  }

  function isAnalyserTrigger(el) {
    if (!el) return false;
    if (el.hasAttribute('data-open-ai-scar-analyser') || el.hasAttribute('data-open-ai-scar-analyzer')) return true;
    if (el.getAttribute('data-bs-target') === '#' + MODAL_ID || el.getAttribute('data-bs-target') === '#ai-scar-analyzer') return true;
    var href = el.getAttribute('href');
    if (!href) return false;
    return (
      href === '#' + MODAL_ID ||
      href.indexOf('#' + MODAL_ID) !== -1 ||
      href === '#ai-scar-analyzer' ||
      href.indexOf('#ai-scar-analyzer') !== -1
    );
  }

  function bindGlobalTriggers() {
    if (document.documentElement.dataset.cpqTriggerBound === 'true') return;
    document.documentElement.dataset.cpqTriggerBound = 'true';

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(
        '[data-open-ai-scar-analyser], [data-open-ai-scar-analyzer], a[href*="#ai-scar-analyser"], a[href*="#ai-scar-analyzer"]'
      );
      if (!trigger || !isAnalyserTrigger(trigger)) return;
      event.preventDefault();
      var analyserUrl =
        (window.ScarProtocol && (window.ScarProtocol.analyzerUrl || window.ScarProtocol.analyserUrl)) || 'https://ai.scarprotocol.com/';
      window.open(analyserUrl, '_blank', 'noopener,noreferrer');
    });
  }

  function initQuiz(root) {
    if (root.dataset.cpqReady === 'true') return;
    root.dataset.cpqReady = 'true';

    var section = root.closest('.cta-product-quiz');
    var config = parseConfig(root) || {
      products: {},
      outcomes: {},
      labels: {},
      stepLabel: 'Step {current} of {total}',
      newsletterTagsBase: 'newsletter,ai-scar-analyser',
      analysing: {
        duration: 3200,
        messages: [
          'Reading your healing timeline…',
          'Comparing scar stages against the 5-phase protocol…',
          'Matching clinical guidance to your answers…',
          'Building your personalised recommendation…'
        ]
      }
    };

    var introStep = root.querySelector('[data-cpq-step="intro"]');
    var situationStep = root.querySelector('[data-cpq-step="situation"]');
    var detailStep = root.querySelector('[data-cpq-step="detail"]');
    var planStep = root.querySelector('[data-cpq-step="plan"]');
    var analysingStep = root.querySelector('[data-cpq-step="analysing"]');
    var resultStep = root.querySelector('[data-cpq-step="result"]');
    var progressFill = root.querySelector('[data-cpq-progress-fill]');
    var progressWrap = root.querySelector('[data-cpq-progress]');
    var resultHeading = root.querySelector('[data-cpq-result-heading]');
    var resultText = root.querySelector('[data-cpq-result-text]');
    var productsWrap = root.querySelector('[data-cpq-products]');
    var emptyWrap = root.querySelector('[data-cpq-empty]');
    var newsletterNote = root.querySelector('[data-cpq-newsletter-note]');
    var newsletterTags = root.querySelector('[data-cpq-newsletter-tags]');
    var analysingStatus = root.querySelector('[data-cpq-analysing-status]');
    var analysingFill = root.querySelector('[data-cpq-analysing-fill]');
    var productTemplate = getTemplate(section);
    var analyseTimer = null;
    var analyseMessageTimer = null;

    var state = {
      step: 'intro',
      situation: null,
      detail: null,
      plan: null,
      outcomeKey: null
    };

    function allSteps() {
      return [introStep, situationStep, detailStep, planStep, analysingStep, resultStep].filter(Boolean);
    }

    function hideAllSteps() {
      allSteps().forEach(function (step) {
        step.hidden = true;
        step.classList.remove('is-active');
      });
    }

    function clearChoicesIn(container) {
      if (!container) return;
      container.querySelectorAll('[data-cpq-choice]').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-checked', 'false');
      });
    }

    function setNextDisabled(stepEl, disabled) {
      if (!stepEl) return;
      var nextBtn = stepEl.querySelector('[data-cpq-next]');
      if (nextBtn) nextBtn.disabled = !!disabled;
    }

    function activePanel(stepEl) {
      if (!stepEl || !state.situation) return null;
      return stepEl.querySelector('[data-cpq-panel="' + state.situation + '"]');
    }

    function showPanelsFor(stepEl) {
      if (!stepEl) return;
      stepEl.querySelectorAll('[data-cpq-panel]').forEach(function (panel) {
        var match = panel.getAttribute('data-cpq-panel') === state.situation;
        panel.hidden = !match;
      });
    }

    function restoreChoiceInPanel(stepEl, value) {
      var panel = activePanel(stepEl);
      if (!panel) {
        setNextDisabled(stepEl, true);
        return;
      }
      clearChoicesIn(panel);
      if (!value) {
        setNextDisabled(stepEl, true);
        return;
      }
      panel.querySelectorAll('[data-cpq-choice]').forEach(function (btn) {
        var selected = btn.dataset.value === value;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      setNextDisabled(stepEl, false);
    }

    function clearAnalyseTimers() {
      if (analyseTimer) {
        window.clearTimeout(analyseTimer);
        analyseTimer = null;
      }
      if (analyseMessageTimer) {
        window.clearInterval(analyseMessageTimer);
        analyseMessageTimer = null;
      }
    }

    function updateProgress() {
      var total = DECISION_STEPS.length;
      var current = 0;
      if (state.step === 'intro') current = 0;
      else if (state.step === 'analysing' || state.step === 'result') current = total;
      else {
        var idx = DECISION_STEPS.indexOf(state.step);
        current = idx >= 0 ? idx + 1 : 1;
      }
      var percent = Math.round((current / total) * 100);
      if (progressFill) progressFill.style.width = percent + '%';
      if (progressWrap) {
        progressWrap.hidden = state.step === 'analysing';
      }
    }

    function showStep(stepId) {
      hideAllSteps();
      state.step = stepId;
      var map = {
        intro: introStep,
        situation: situationStep,
        detail: detailStep,
        plan: planStep,
        analysing: analysingStep,
        result: resultStep
      };
      var el = map[stepId];
      if (!el) return;
      el.hidden = false;
      el.classList.add('is-active');

      if (stepId === 'situation') {
        situationStep.querySelectorAll('[data-cpq-choice]').forEach(function (btn) {
          var selected = btn.dataset.value === state.situation;
          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        setNextDisabled(situationStep, !state.situation);
      }

      if (stepId === 'detail') {
        showPanelsFor(detailStep);
        restoreChoiceInPanel(detailStep, state.detail);
      }

      if (stepId === 'plan') {
        showPanelsFor(planStep);
        restoreChoiceInPanel(planStep, state.plan);
      }

      updateProgress();
    }

    function resolveOutcomeKey() {
      if (state.situation === 'surgery') {
        return state.plan === 'heal' ? 'phase_1' : 'full_kit';
      }
      if (state.situation === 'resurfacing') return 'phase_1';
      if (state.situation === 'old') {
        return state.plan === 'start' ? 'phase_4' : 'old_scar';
      }
      if (state.situation === 'fresh') {
        if (state.plan === 'longer') return 'full_kit';
        return AGE_TO_PHASE[state.detail] || null;
      }
      return null;
    }

    function createProductCard(product, badgeText) {
      if (!product || !productTemplate) return null;
      var node = productTemplate.content.firstElementChild.cloneNode(true);
      var badge = node.querySelector('[data-cpq-product-badge]');
      var image = node.querySelector('[data-cpq-product-image]');
      var title = node.querySelector('[data-cpq-product-title]');
      var price = node.querySelector('[data-cpq-product-price]');
      var link = node.querySelector('[data-cpq-product-link]');

      if (badge) {
        if (badgeText) {
          badge.hidden = false;
          badge.textContent = badgeText;
        } else {
          badge.hidden = true;
        }
      }
      if (title) title.textContent = product.title || '';
      if (price) price.textContent = product.price || '';
      if (link) link.href = product.url || '#';
      if (image) {
        if (product.image) {
          image.src = product.image;
          image.alt = product.title || 'Recommended product';
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      }
      return node;
    }

    function renderProducts(outcome) {
      if (!productsWrap) return 0;
      productsWrap.innerHTML = '';
      var labels = config.labels || {};
      var count = 0;
      var isSequence = !!outcome.sequence;
      var primaryKeys = outcome.primary || [];
      var secondaryKeys = outcome.secondary || [];

      primaryKeys.forEach(function (key, index) {
        var product = (config.products || {})[key];
        if (!product) return;
        var badge = labels.primary || 'Best match';
        if (isSequence) {
          badge =
            index === 0
              ? labels.sequenceStart || 'Start with'
              : labels.sequenceNext || 'Then use';
        }
        var card = createProductCard(product, badge);
        if (card) {
          productsWrap.appendChild(card);
          count += 1;
        }
      });

      if (!isSequence) {
        secondaryKeys.forEach(function (key) {
          if (primaryKeys.indexOf(key) !== -1) return;
          var product = (config.products || {})[key];
          if (!product) return;
          var card = createProductCard(product, labels.runnerUp || 'Also consider');
          if (card) {
            card.classList.add('cpq-product--secondary');
            productsWrap.appendChild(card);
            count += 1;
          }
        });
      }

      return count;
    }

    function paintResult() {
      var outcomeKey = resolveOutcomeKey();
      state.outcomeKey = outcomeKey;

      var outcome = outcomeKey && config.outcomes ? config.outcomes[outcomeKey] : null;
      if (!outcome) {
        if (resultHeading) resultHeading.textContent = '';
        if (resultText) resultText.textContent = '';
        if (productsWrap) productsWrap.innerHTML = '';
        if (emptyWrap) emptyWrap.hidden = false;
        if (newsletterNote) newsletterNote.value = 'ai-scar-analyser:no-match';
        if (newsletterTags) {
          newsletterTags.value = config.newsletterTagsBase || 'newsletter,ai-scar-analyser';
        }
        return;
      }

      // Fresh scar + longer plan: Full Kit primary, current-stage phase as "Also consider"
      if (
        outcomeKey === 'full_kit' &&
        state.situation === 'fresh' &&
        state.plan === 'longer'
      ) {
        var stagePhase = AGE_TO_PHASE[state.detail];
        if (stagePhase) {
          outcome = Object.assign({}, outcome, { secondary: [stagePhase] });
        }
      }

      if (resultHeading) resultHeading.textContent = outcome.heading || 'Your recommendation';
      if (resultText) resultText.textContent = outcome.text || '';

      var rendered = renderProducts(outcome);
      if (emptyWrap) emptyWrap.hidden = rendered > 0;
      if (rendered === 0 && productsWrap) productsWrap.innerHTML = '';

      if (newsletterNote) {
        newsletterNote.value = 'ai-scar-analyser:' + outcomeKey;
      }
      if (newsletterTags) {
        var base = config.newsletterTagsBase || 'newsletter,ai-scar-analyser';
        newsletterTags.value = base + ',' + outcomeKey;
      }
    }

    function runAnalysingThenResult() {
      clearAnalyseTimers();
      showStep('analysing');

      var analysing = config.analysing || {};
      var messages = (analysing.messages || []).filter(Boolean);
      if (!messages.length) {
        messages = ['Analysing your scar profile…'];
      }
      var duration = Number(analysing.duration) || 3200;
      var messageIndex = 0;

      if (analysingFill) {
        analysingFill.style.width = '0%';
        analysingFill.style.transition = 'none';
        window.requestAnimationFrame(function () {
          analysingFill.style.transition = 'width ' + duration + 'ms linear';
          analysingFill.style.width = '100%';
        });
      }

      if (analysingStatus) analysingStatus.textContent = messages[0];
      analyseMessageTimer = window.setInterval(function () {
        messageIndex += 1;
        if (messageIndex >= messages.length) {
          window.clearInterval(analyseMessageTimer);
          analyseMessageTimer = null;
          return;
        }
        if (analysingStatus) analysingStatus.textContent = messages[messageIndex];
      }, Math.max(400, Math.floor(duration / messages.length)));

      analyseTimer = window.setTimeout(function () {
        clearAnalyseTimers();
        paintResult();
        showStep('result');
      }, duration);
    }

    function goNextFrom(stepId) {
      if (stepId === 'situation') {
        if (!state.situation) return;
        showStep('detail');
        return;
      }
      if (stepId === 'detail') {
        if (!state.detail) return;
        showStep('plan');
        return;
      }
      if (stepId === 'plan') {
        if (!state.plan) return;
        runAnalysingThenResult();
      }
    }

    function goBackFrom(stepId) {
      if (stepId === 'situation') {
        showStep('intro');
        return;
      }
      if (stepId === 'detail') {
        showStep('situation');
        return;
      }
      if (stepId === 'plan') {
        showStep('detail');
        return;
      }
      if (stepId === 'result') {
        showStep('plan');
      }
    }

    function applyChoice(stepEl, btn) {
      var value = btn.dataset.value;
      var panel = btn.closest('[data-cpq-panel]');
      var scope = panel || stepEl;

      scope.querySelectorAll('[data-cpq-choice]').forEach(function (el) {
        var selected = el === btn;
        el.classList.toggle('is-selected', selected);
        el.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      setNextDisabled(stepEl, !value);

      if (stepEl === situationStep) {
        state.situation = value;
        state.detail = null;
        state.plan = null;
        if (detailStep) {
          detailStep.querySelectorAll('[data-cpq-panel]').forEach(function (p) {
            clearChoicesIn(p);
          });
          setNextDisabled(detailStep, true);
        }
        if (planStep) {
          planStep.querySelectorAll('[data-cpq-panel]').forEach(function (p) {
            clearChoicesIn(p);
          });
          setNextDisabled(planStep, true);
        }
      } else if (stepEl === detailStep) {
        state.detail = value;
        state.plan = null;
        if (planStep) {
          planStep.querySelectorAll('[data-cpq-panel]').forEach(function (p) {
            clearChoicesIn(p);
          });
          setNextDisabled(planStep, true);
        }
      } else if (stepEl === planStep) {
        state.plan = value;
      }
      updateProgress();
    }

    function resetAll() {
      clearAnalyseTimers();
      state.situation = null;
      state.detail = null;
      state.plan = null;
      state.outcomeKey = null;
      clearChoicesIn(situationStep);
      setNextDisabled(situationStep, true);
      if (detailStep) {
        detailStep.querySelectorAll('[data-cpq-panel]').forEach(clearChoicesIn);
        setNextDisabled(detailStep, true);
      }
      if (planStep) {
        planStep.querySelectorAll('[data-cpq-panel]').forEach(clearChoicesIn);
        setNextDisabled(planStep, true);
      }
      if (productsWrap) productsWrap.innerHTML = '';
      if (emptyWrap) emptyWrap.hidden = true;
      if (analysingFill) {
        analysingFill.style.transition = 'none';
        analysingFill.style.width = '0%';
      }
      if (analysingStatus) analysingStatus.textContent = '';
      showStep('intro');
    }

    root.addEventListener('click', function (event) {
      var startBtn = event.target.closest('[data-cpq-start]');
      if (startBtn) {
        event.preventDefault();
        showStep('situation');
        return;
      }

      var choiceBtn = event.target.closest('[data-cpq-choice]');
      if (choiceBtn && root.contains(choiceBtn)) {
        event.preventDefault();
        var stepEl = choiceBtn.closest('[data-cpq-step]');
        applyChoice(stepEl, choiceBtn);
        return;
      }

      var nextBtn = event.target.closest('[data-cpq-next]');
      if (nextBtn && root.contains(nextBtn)) {
        event.preventDefault();
        goNextFrom(state.step);
        return;
      }

      var backBtn = event.target.closest('[data-cpq-back]');
      if (backBtn && root.contains(backBtn)) {
        event.preventDefault();
        goBackFrom(state.step);
        return;
      }

      var restartBtn = event.target.closest('[data-cpq-restart]');
      if (restartBtn && root.contains(restartBtn)) {
        event.preventDefault();
        resetAll();
      }
    });

    var modalEl = document.getElementById(MODAL_ID);
    if (modalEl && !modalEl.dataset.cpqResetBound) {
      modalEl.dataset.cpqResetBound = 'true';
      modalEl.addEventListener('hidden.bs.modal', function () {
        clearAnalyseTimers();
        resetAll();
      });
    }

    showStep('intro');
  }

  function initAll() {
    bindGlobalTriggers();
    document.querySelectorAll('[data-cpq-root]').forEach(initQuiz);
    if (window.location.hash === '#' + MODAL_ID) {
      openAnalyserModal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindGlobalTriggers();
    var root = event.target.querySelector('[data-cpq-root]');
    if (root) {
      root.dataset.cpqReady = 'false';
      initQuiz(root);
    }
  });
})();
